import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CaseTimeLine from "./case-timeline";
import CaseSummary from "./case-summary";
import CaseAttachments from "./case-attachments";
import { useParams } from "react-router-dom";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const OtherDetails = ({ caseDetails, onSuccess }) => {
  const { caseId } = useParams();
  // const [complaintTypeList, setcomplaintTypeList] = useState([]);
  // const [dcList, setDcList] = useState([]);
 
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [caseTimeLines, setCaseTimeLines] = useState([]);

  useEffect(() => {
    loadData();
  }, [caseDetails]);

  const loadData = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.TIME_LINE}${caseId}`
    ).then((response) => {
      if (response && Array.isArray(response)) {
        setCaseTimeLines(response);
      }
    });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Case Summary" {...a11yProps(0)} />
          <Tab label="Case History" {...a11yProps(1)} />
          <Tab label="Case Attachments" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <CaseSummary
          // complaintTypeList={complaintTypeList}
          caseDetails={caseDetails}
          // dcList={dcList}
          onSuccess={onSuccess}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <CaseTimeLine caseTimeLines={caseTimeLines} caseDetails={caseDetails} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <CaseAttachments caseTimeLines={caseTimeLines} />
      </TabPanel>
    </Box>
  );
};

export default OtherDetails;
